<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{initData.sa_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sa_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{initData.sa_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value">{{initData.sa_custcontact}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收货地址</label>
            <span class="weui-form-preview__value">{{initData.sa_toplace}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">操作</label>
            <span class="weui-form-preview__value">{{initData.sa_detno}}</span>
          </div> -->
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in initData.orderDetails" :key="item.sd_detno">
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料编号</label>
            <span class="weui-form-preview__value">{{item.sd_custprodcode}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.saleChangeDTO.sc_change_time}}</span>
          </div> -->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.sd_custproddetail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.sd_custorispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{item.sd_qty}} {{ item.sd_custprodunit }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">取消数量</label>
            <span class="weui-form-preview__value">{{item.sd_unqty}} {{ item.sd_custprodunit }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sd_delivery}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交期回复</label>
            <span class="weui-form-preview__value">{{item.sd_custorispeccode}}</span>
          </div> -->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sd_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.sd_custprodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.sd_custprodbrand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.sd_custprodspec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <div class="weui-form-preview__value text-link">
              <span v-if="!item.isCancel" @click="onCancel(item)">转订单取消</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  data() {
    return {

    }
  },
  methods: {
    onCancel(item) {
      let me = this

      let jsonData = {
        custid: item.sd_custid,
        fromType: "Purchase",
        osMakeMainId: item.sd_maid,
        purDetailId: item.sd_pdid,
        qty: item.sd_qty
      }

      me.$loading({
        url: "/api/sale/saledown/cancel",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("已取消成功", 2000);
          me.$router.back()
          // me.tempRejectIndex = undefined
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  },
};
</script>